<template>
  <v-autocomplete v-model="form.presentation_id"
                  label="Add a presentation to this space"
                  outlined
                  dense
                  clearable
                  :items="availablePresentations"
                  item-value="id"
                  item-text="name"
                  @input="submit"
                  :error-messages="form.errors.get('presentation_id')"
                  :menu-props="menuProps"
                  no-data-text="No presentations can be added to this space."
                  :disabled="busy || form.busy">
  </v-autocomplete>
</template>
<script>
import {Form} from 'vform';
import {mapGetters} from 'vuex';
import DOMPurify from 'dompurify';

export default {
  props: {
    assets: {
      type: Array,
      required: true,
    },
    busy: {
      type: Boolean,
      required: false,
      default: false,
    },
    space: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: new Form({
        presentation_id: '',
      })
    }
  },
  computed: {
    ...mapGetters([
      'activePresentations',
      'team',
      'user',
    ]),
    menuProps() {
      // @see https://v2.vuetifyjs.com/en/api/v-autocomplete/#props-menu-props
      // @see https://v2.vuetifyjs.com/en/api/v-menu/#props
      return {
        closeOnClick: false,
        closeOnContentClick: false,
      }
    },
    presentationIDs() {
      return this.assets
        .filter(a => a.is_presentation)
        .map(a => a.presentation_id);
    },
    availablePresentations() {
      return this.activePresentations.filter(p => {
        return this.presentationIDs.includes(p.id) === false;
      })
    },
  },
  methods: {
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.post(`/api/spaces/${this.space.id}/presentations`)
        .then(response => {
          if (response.data?.message) {
            this.$toast.success(DOMPurify.sanitize(response.data?.message));
          }
          this.form.reset();
          this.$emit('added')
        })
        .catch(() => {
        })
    }
  }
}
</script>
